import {liveEvent} from './util'

const delay = 8000
let carouselIndex = 0

let timer
let startX
let scrollLeft
let swipeRatio
let dragging = false
let titleOffset = 0

const setIndex = (prev, next) => {
	const imageRect = document.querySelector('.carousel .image-wrapper .carousel-image').getBoundingClientRect()
	const titleRect = document.querySelector('.carousel .title-wrapper .carousel-title').getBoundingClientRect()
	
	const imageOffset = next * imageRect.width
	titleOffset = next * titleRect.width

	document.querySelectorAll('.carousel .image-wrapper .carousel-image').forEach(e => {
		e.style.transform = `translateX(-${imageOffset}px)`
	})
	
	document.querySelectorAll('.carousel .title-wrapper .carousel-title').forEach(e => {
		e.style.transform = `translateX(-${titleOffset}px)`
	})

	document.querySelector(`#carousel-bullet-${prev}`).classList.remove('active')
	document.querySelector(`#carousel-bullet-${next}`).classList.add('active')
}

const endSlideSwipe = () => {
	document.querySelectorAll('.carousel .title-wrapper .carousel-title').forEach(e => {
		e.style.transitionDuration = '0.4s'
	})

	const absRatio = Math.abs(swipeRatio)
	
	if(absRatio > 0.36) {
		if(swipeRatio < 0 && carouselIndex > 0) {
			setIndex(carouselIndex, carouselIndex - 1)
			carouselIndex = carouselIndex - 1
		} else if(swipeRatio > 0 && carouselIndex < 3) {
			setIndex(carouselIndex, carouselIndex + 1)
			carouselIndex = carouselIndex + 1
		}
	} else {
		document.querySelector('.carousel .title-wrapper').scrollLeft = 0
		setIndex(carouselIndex, carouselIndex)
	}

	swipeRatio = 0
	dragging = false
}

const onPointerMove = e => {
	e.preventDefault()
	dragging = true
	
	const rect = document.querySelector('.carousel .title-wrapper').getBoundingClientRect()
	const {left, width} = rect
	const {offsetX, pageX} = e

	const offs = scrollLeft - (pageX - startX)

	if(carouselIndex === 0 && offs < 0) {
		swipeRatio = 0
		return
	}

	if(carouselIndex === 3 && offs > 0) {
		swipeRatio = 0
		return
	}

	swipeRatio = offs / width
	document.querySelectorAll('.carousel .title-wrapper .carousel-title').forEach(e => {
		e.style.transform = `translateX(-${titleOffset - (pageX - startX)}px)`
	})	
}

const initializeCarousel = () => {
	timer = setInterval(() => {
		const prevIndex = carouselIndex
		
		if(carouselIndex < 3) {
			carouselIndex = carouselIndex + 1
		} else {
			carouselIndex = 0
		}


		setIndex(prevIndex, carouselIndex)

	}, delay)

	document.querySelector('.carousel .title-wrapper').addEventListener('click', (e) => {
		if(!dragging) {
			return true
		}

		endSlideSwipe()

		document.querySelector('body').removeEventListener('pointermove', onPointerMove)
		e.preventDefault()
		return false
	})

	document.querySelector('.carousel .title-wrapper').addEventListener('pointerdown', (e) => {
		startX = e.pageX
		scrollLeft = document.querySelector('.carousel .title-wrapper').scrollLeft

		document.querySelectorAll('.carousel .title-wrapper .carousel-title').forEach(e => {
			e.style.transitionDuration = '0s'
		})

		document.querySelector('body').addEventListener('pointermove', onPointerMove)

		if(timer) {
			clearInterval(timer)
			timer = null
		}
	})

	window.addEventListener('pointerup', (e) => {
		if(!dragging) {
			return
		}
		
		let el = e.target
		while(el && !el.classList.contains('title-wrapper')) {
			el = el.parentElement
		}

		// we'ree inside carousel, so listener will be removed in click event
		if(el) {
			return
		}

		endSlideSwipe()

		document.querySelector('body').removeEventListener('pointermove', onPointerMove)
	})

	window.addEventListener('pagehide', () => {
		dragging = false
		document.querySelector('body').removeEventListener('pointermove', onPointerMove)
	})

	liveEvent(document.querySelector('.carousel .carousel-bullets'), 'click', 'carousel-bullet', e => {
		const m = e.id.match(/^carousel-bullet-(\d+)$/)
		if(!m) {
			return
		}

		const index = parseInt(m[1], 10)
		const prevIndex = carouselIndex
		carouselIndex = index

		setIndex(prevIndex, index)
	})
}

const wrapper = document.querySelector('section.news-carousel .carousel')
if(wrapper) {
	initializeCarousel()
}
